var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBriefcase = function SvgIconBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 9.5a1 1 0 1 0 0 2h2.25a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 2a2.5 2.5 0 0 0-2.5 2.5v.875h-3.5A1.75 1.75 0 0 0 2 7.125v12c0 .966.784 1.75 1.75 1.75h16.5a1.75 1.75 0 0 0 1.75-1.75v-12a1.75 1.75 0 0 0-1.75-1.75h-3.5V4.5a2.5 2.5 0 0 0-2.5-2.5zM4 18.875v-5.761a18.84 18.84 0 0 0 8 1.761c2.77.003 5.5-.602 8-1.763v5.763zm8.001-6c2.793.003 5.54-.684 8-1.997V7.375H4v3.504a16.84 16.84 0 0 0 7.997 1.996zm2.75-7.5V4.5a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0-.5.5v.875z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBriefcase;